import React from 'react';
import { Breadcrumb } from './Breadcrumb';

export type SingleCrumbProps = { name: string };

export const SingleCrumb = ({ name }: SingleCrumbProps): JSX.Element => (
    <Breadcrumb>
        <Breadcrumb.Item>{name}</Breadcrumb.Item>
    </Breadcrumb>
);
